<!--模板-->
<template>
  <div id="download">
    <div class="card_bg">
      <div class="card_img">
        <img src="../../../static/images/index/we.jpg" alt="">
      </div>
      <div class="card_text">
        <h3>立即下载APP，认识附近1公里的 Ta ~</h3>
        <!--        <h1>APP即将上线，敬请期待 ~</h1>-->
        <br>
        <br>
        <h4>让距离不再是问题 。</h4>
        <h4>让孤单统统走开 。</h4>
        <h4>让你我再近一点 。</h4>
        <h4>让彼此更加温暖 。</h4>
      </div>
      <div class="card_btn">
                <p  @click="down(0)"><span class="iconfont icon-ios"></span>AppStore</p>
        <p @click="down(1)"><span class="iconfont icon-anzhuo"></span>Android</p>
        <p @click="down(2)"><span class="iconfont icon-xiaochengxu"></span>微信小程序</p>
      </div>
    </div>
    <el-dialog :visible.sync="centerDialogVisible" width="60%" center>
      <div class="wxImg">
        <img src="../../../static/images/index/wechat.jpg" alt="">
        <p>打开微信扫描，扫描上方小程序码，进入【陪伴玩】<span class="iconfont icon-xiaochengxu"></span>微信小程序</p>
      </div>
    </el-dialog>
  </div>
</template>


<!--JS-->
<script>
  export default {
    data() {
      return {
        centerDialogVisible: false
      };
    },
    methods: {
      down(index) {
        if (index == 0) {
          window.location.href = 'https://apps.apple.com/cn/app/id1478709039'
        }
        if (index == 1) {
          window.location.href = 'https://android.myapp.com/myapp/detail.htm?apkName=com.peibanwan.app'
        }
        if (index == 2) {
          this.centerDialogVisible = true
        }
      }
    }
  };
</script>


<!--css样式-->
<style lang="scss" scoped>
  @import '../../../src/scss/commonH5.scss';
  .wxImg {
    width: 100%;
    text-align: center;
  }
  .card_btn {
    color: #fff;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    width: 510px;
    p {
      font-size: 20px;
      margin: 0 20px;
      background: #f60;
      padding: 10px 20px;
      border-radius: 20px;
      span {
        padding-right: 10px;
        font-size: 20px;
      }
    }
  }
  #download {
    width: 100%;
    height: 100vh;
    background: url("../../../static/images/index/down.jpg")no-repeat 100% 100%;
    background-size: cover;
    display: flex;
    align-items: center;
    justify-content: left;
  }
  .card_bg {
    display: flex;
    background: rgba(0, 0, 0, 0.3);
    width: 80%;
    margin: 0 auto;
    padding: 20px;
    border-radius: 10px;
  }
  .card_text {
    align-items: center;
    color: #fff;
    font-weight: bold;
  }
  .card_img {
    display: flex;
    align-items: center;
  }
  .card_img img {
    width: 200px;
    height: 200px;
    margin-right: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/views/about/download.vue